import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import ReplaceableField from "./ReplaceableField";
import LuciPropTypes from "../../propTypes";
import { actions as assetActions } from "../../actions/asset";
import { actions as axisOrderActions } from "../../actions/axisOrder";

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

class MediaReplaceableSidebar extends Component {
  onReplaceableSelect = replaceable => {
    this.props.onSelectItem(
      replaceable.properties.axisOrderAssetType,
      replaceable.properties.axisOrderMediaFormat,
      replaceable.properties.displayName,
      replaceable.id,
      replaceable.type
    );
  };
  render() {
    return (
      <Container>
        {this.props.mediaReplaceables
          .filter(
            replaceable =>
              replaceable.type === this.props.assetType ||
              this.props.assetType === "*"
          )
          .map(replaceable => {
            if (!replaceable.properties["read only"]) {
              return (
                <ReplaceableField
                  key={replaceable.id}
                  replaceableId={replaceable.id}
                  updateReplaceableValue={this.props.updateReplaceableValue}
                  onDoubleClick={() => this.onReplaceableSelect(replaceable)}
                />
              );
            }
            return "";
          })}
      </Container>
    );
  }
}

MediaReplaceableSidebar.defaultProps = {
  mediaReplaceables: [],
  updateReplaceableValue: () => {},
  assetType: "*",
  onSelectItem: PropTypes.func.isRequired
};

MediaReplaceableSidebar.propTypes = {
  mediaReplaceables: PropTypes.arrayOf(LuciPropTypes.Replaceable),
  updateReplaceableValue: PropTypes.func,
  assetType: PropTypes.string,
  onSelectItem: PropTypes.func
};

const mapStateToProps = state => ({
  mediaReplaceables:
    state.asset.templateDefinition &&
    state.asset.templateDefinition.mediaReplaceables
      ? state.asset.templateDefinition.mediaReplaceables
      : []
});

const mapActionCreators = {
  updateReplaceableValue: assetActions.updateReplaceableValue,
  onSelectItem: axisOrderActions.startAddItem
};

export default connect(
  mapStateToProps,
  mapActionCreators
)(MediaReplaceableSidebar);



// WEBPACK FOOTER //
// ./app/components/Editor/MediaReplaceableSidebar.js